import {createApp} from "vue"
import Cleave from "vue-cleave-component"
import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption
} from "@headlessui/vue"
import VueCountdown from '@chenfengyuan/vue-countdown';
import i18n from "./i18n"
import PortalVue from "portal-vue"
import DateInput from "./components/Date"
import ImageUpload from "./components/ImageUpload";
import RepeatFields from "./components/RepeatFields";
import Toggle from "./components/Toggle";

const app = createApp({
    components: {
        Cleave,
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        RadioGroup,
        RadioGroupLabel,
        RadioGroupOption,
        'tw-menu': Menu,
        MenuButton,
        MenuItems,
        MenuItem,
        DateInput,
        ImageUpload,
        RepeatFields,
        Toggle,
        VueCountdown,
    },
    data() {
        return {
            navigationOpen: false,
        }
    },
    methods: {
        redirect(url) {
            window.location.replace(url);
        }
    }
});
app.use(i18n)
app.use(PortalVue)

export default app
